import React from 'react'

const FailedIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
        <mask id="mask0_5160_58247"  maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="24">
            <rect x="0.333984" width="24" height="24" fill="#D9D9D9"/>
        </mask>
        <g mask="url(#mask0_5160_58247)">
            <path d="M6.73398 19L5.33398 17.6L10.934 12L5.33398 6.4L6.73398 5L12.334 10.6L17.934 5L19.334 6.4L13.734 12L19.334 17.6L17.934 19L12.334 13.4L6.73398 19Z" fill="#FE5555"/>
        </g>
    </svg>
  )
}

export default FailedIcon
